import { useLayoutEffect } from "react";
import homeIconSrc from "assets/home.svg";
import assetsIconSrc from "assets/my-assets.svg";
import tradingIconSrc from "assets/trading.svg";
import transactionsIconSrc from "assets/transactions.svg";
import transfersIconSrc from "assets/transfers.svg";
import classNames from "classnames";
import { useGetPortfolioOptions } from "hooks/useGetPortfolioOptions";
import { TOTAL_INVESTMENTS_OPTION_ID } from "hooks/useGetPortfolioOptions";
import { useModifiedTranslation } from "hooks/useModifiedTranslation";
import { PortfolioOption } from "layouts/PortfolioNavigationHeaderLayout/PortfolioNavigationHeader/PortfolioNavigationHeader";
import { useTheme } from "providers/ThemeProvider";
import {
  useLocation,
  Link,
  useParams,
  useSearchParams,
} from "react-router-dom";

const mobileRoutes = [
  {
    path: "overview",
    tabLabelKey: "home",
    icon: homeIconSrc,
  },
  {
    path: "holdings",
    tabLabelKey: "my_assets",
    icon: assetsIconSrc,
  },
  {
    path: "trading",
    tabLabelKey: "trading",
    icon: tradingIconSrc,
  },
  {
    path: "transfers",
    tabLabelKey: "transfers",
    icon: transfersIconSrc,
  },
  {
    path: "transactions",
    tabLabelKey: "transactions",
    icon: transactionsIconSrc,
  },
];

const getFullPath = (path: string, portfolioId?: string) => {
  return portfolioId ? `/portfolio/${portfolioId}/${path}` : `/${path}`;
};

export const MobileNavSpacer = () => {
  return <div className="block sm:hidden h-[60px]"></div>;
};

const MobileStickyNavigation = () => {
  const { t } = useModifiedTranslation();
  const portfolioOptions = useGetPortfolioOptions();

  const location = useLocation();
  const activePath = location.pathname.split("/").slice(-1)[0];
  const { portfolioId } = useParams();

  const { setIsDarkMode } = useTheme();
  const [searchParams] = useSearchParams();
  const isAdvancedMode = searchParams.get("mode") === "advanced";

  // Set theme based on mode when query params change
  useLayoutEffect(() => {
    setIsDarkMode(isAdvancedMode);
  }, [isAdvancedMode, setIsDarkMode]);

  const hasMultiplePortfolios =
    portfolioOptions.filter(
      (p: PortfolioOption) => p.id !== TOTAL_INVESTMENTS_OPTION_ID
    ).length > 1;
  const shouldFilterNav =
    location.pathname === "/overview" && hasMultiplePortfolios;

  const routesToShow = shouldFilterNav
    ? mobileRoutes.filter((route) => route.path === "overview")
    : mobileRoutes;

  return (
    <div className="block sm:hidden fixed bottom-0 z-50 w-screen bg-white shadow-[0_-5px_10px_0px_rgba(0,0,0,0.1)]">
      <div className="flex justify-between items-center px-4 pt-3 pb-1 font-medium text-kvarn-dark-green">
        {routesToShow.map((route) => {
          const isActive = activePath === route.path;
          return (
            <Link
              key={route.path}
              to={getFullPath(route.path, portfolioId)}
              className="flex flex-col gap-1 items-center"
            >
              <div className="w-[20px] h-[20px]">
                <img
                  src={route.icon}
                  alt={t("stickyNav." + route.tabLabelKey)}
                  style={{
                    filter: isActive
                      ? "brightness(0) saturate(100%) invert(58%) sepia(76%) saturate(454%) hue-rotate(116deg) brightness(82%) contrast(89%)"
                      : "none",
                  }}
                />
              </div>
              <div
                className={classNames("text-xs", {
                  "font-bold": isActive,
                })}
              >
                {t("stickyNav." + route.tabLabelKey)}
              </div>
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MobileStickyNavigation;
